// Hours/minutes helpers. Hours are floats (8.25 = 08:15).
export function parseEst(est) {
    if (!est)
        return 0;
    const s = String(est).toLowerCase().trim().replace(/\s+/g, '').replace(',', '.');
    const m = s.match(/^(\d+(?:\.\d+)?)(h|m|min)?$/);
    if (!m)
        return 0;
    const n = parseFloat(m[1]);
    const u = m[2] || 'h';
    return u.startsWith('m') ? n / 60 : n;
}
export function fmtDur(hours) {
    if (hours >= 1) {
        const rounded = Math.round(hours * 10) / 10;
        return rounded % 1 === 0 ? `${rounded}h` : `${rounded}h`;
    }
    return `${Math.round(hours * 60)}m`;
}
export function fmtTime(h) {
    const hh = Math.floor(h);
    const mm = Math.round((h - hh) * 60);
    return `${String(hh).padStart(2, '0')}:${String(mm).padStart(2, '0')}`;
}
export function msToHuman(ms) {
    const s = Math.round(ms / 1000);
    if (s < 60)
        return `${s}s`;
    const m = Math.floor(s / 60);
    if (m < 60)
        return `${m}min`;
    const h = Math.floor(m / 60);
    const mm = m % 60;
    return mm ? `${h}h${mm}m` : `${h}h`;
}
export function weekMondayFromOffset(offset = 0, now = new Date()) {
    const d = new Date(now);
    const dow = d.getDay();
    const offsetToMon = dow === 0 ? -6 : 1 - dow;
    const mon = new Date(d);
    mon.setDate(d.getDate() + offsetToMon + offset * 7);
    mon.setHours(0, 0, 0, 0);
    return mon;
}
export function hoursFromDate(d) {
    return d.getHours() + d.getMinutes() / 60 + d.getSeconds() / 3600;
}
export function snap15(h) {
    return Math.round(h * 4) / 4;
}
export function dueToUrgDays(due) {
    if (!due)
        return null;
    const lower = due.toLowerCase().trim();
    if (lower === 'heute')
        return 1;
    if (lower === 'morgen')
        return 2;
    const m = lower.match(/^\+(\d+)[tw]$/i);
    if (m) {
        const n = parseInt(m[1], 10);
        return due.toLowerCase().endsWith('w') ? n * 7 : n;
    }
    const parsed = new Date(due);
    if (!Number.isNaN(parsed.getTime())) {
        const days = Math.ceil((parsed.getTime() - Date.now()) / 86400000);
        return days;
    }
    return null;
}
export function groupFromUrgDays(urg) {
    if (urg == null)
        return 'backlog';
    if (urg <= 1)
        return 'today';
    if (urg <= 3)
        return 'high';
    if (urg <= 7)
        return 'medium';
    if (urg <= 21)
        return 'low';
    return 'backlog';
}
export function urgFactorFromDays(urg) {
    if (urg == null)
        return 0.6;
    if (urg <= 1)
        return 1.6;
    if (urg <= 3)
        return 1.4;
    if (urg <= 7)
        return 1.0;
    return 0.6;
}
